import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2020-12-02
	search(params) {
		return axios.get('/delivery-requisitions?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2020-12-02
	create(params) {
		return axios.post('/delivery-requisitions', params)
	},
	// 2020-12-02
	delete(id) {
		return axios.delete('/delivery-requisitions/' + id)
	},

	// 2020-12-02
	reject(id, params) {
		return axios.put('/delivery-requisitions/' + id + '/reject', params)
	},
	// 2020-12-02
	deliver(id, params) {
		return axios.put('/delivery-requisitions/' + id + '/deliver', params)
	},

	// 2020-11-30
	findBySerialNo(params) {
		return axios.get('/delivery-requisitions/find-by-serial-no', params);
	},
	// 2020-12-01
	findByOrderSerialNo(params) {
		return axios.get('/delivery-requisitions/find-by-order-serial-no', params);
	},
	// 2021-02-24
	undeliverCount() {
		return axios.get('/delivery-requisitions/undeliver-count')
	},

	// 2021-03-13
	rejectCount() {
		return axios.get('/delivery-requisitions/reject-count')
	},
	// 2020-12-02
	findById(id) {
		return axios.get('/delivery-requisitions/' + id)
	}

}

